module.exports = __webpack_public_path__ + "img/service-02.356f3ce7.svg";